import ZoneManagerViewTraAtd from '../../features/zoneManager/ZoneManagerViewTraAtd'

const ZoneManagerViewTraAtdPage = () => {
  return <ZoneManagerViewTraAtd/>
}

export default ZoneManagerViewTraAtdPage